import { HFBox, HFSkeleton } from '@hf/designSystem/v1';

const HEADER_CELLS = 6;
const BODY_ROWS = 6;

/** A header row and body rows that fill the table slot, so the card does not jump when data arrives. */
export function TableSkeleton({ testId }: { testId: string }) {
  return (
    <HFBox
      data-testid={testId}
      aria-hidden
      sx={{ height: '100%', display: 'flex', flexDirection: 'column', border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}
    >
      <HFBox sx={{ display: 'flex', gap: 2, px: 1.5, py: 1.25, borderBottom: 1, borderColor: 'divider' }}>
        {Array.from({ length: HEADER_CELLS }, (_, index) => (
          <HFSkeleton key={index} variant="rounded" height={12} sx={{ flex: 1 }} />
        ))}
      </HFBox>
      <HFBox sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        {Array.from({ length: BODY_ROWS }, (_, row) => (
          <HFBox
            key={row}
            sx={{ flex: 1, minHeight: 0, display: 'flex', gap: 2, alignItems: 'center', px: 1.5, borderBottom: 1, borderColor: 'divider' }}
          >
            {Array.from({ length: HEADER_CELLS }, (_, column) => (
              <HFSkeleton key={column} variant="rounded" height={12} sx={{ flex: 1 }} />
            ))}
          </HFBox>
        ))}
      </HFBox>
    </HFBox>
  );
}
